// @flow

import clsx from 'clsx';

import { Base, Button, Svg, Text } from '@gandi/ui';

import styles from './UserActionRow.scss';

export type Props = { href?: string, message: string, buttonLabel: string };

export function UserActionRow({
  buttonLabel,
  href,
  message,
}: Props): React.MixedElement {
  return (
    <Base
      flex
      flexAlignItemsCenter
      flexWrap
      gap="small"
      padding="small"
      backgroundColor="neutral-strong"
      color="white"
      borderRadius="2x"
      marginBottom="base"
    >
      <Base
        flex
        flexJustifyCenter
        flexAlignItemsCenter
        className={styles.iconContainer}
      >
        <Svg name="user" theme="white" size="5x" />
      </Base>
      <Text weight="semibold" className={styles.text}>
        {message}
      </Text>
      <Button
        kind="outline"
        href={href}
        className={clsx(styles.button, styles.dark)}
      >
        {buttonLabel}
      </Button>
    </Base>
  );
}
